/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Users_Form_Clients_Selected_CountInputs */

const en_users_form_clients_selected_count = /** @type {(inputs: Users_Form_Clients_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} client(s) selected`)
};

const pt_br2_users_form_clients_selected_count = /** @type {(inputs: Users_Form_Clients_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cliente(s) selecionado(s)`)
};

/**
* | output |
* | --- |
* | "{count} client(s) selected" |
*
* @param {Users_Form_Clients_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_selected_count = /** @type {((inputs: Users_Form_Clients_Selected_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_Selected_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_selected_count(inputs)
	return pt_br2_users_form_clients_selected_count(inputs)
});